import {makeStyles} from '@material-ui/core'

export const useStyles = makeStyles(() => ({
  title: {
    fontWeight: 700,
    fontSize: '20px',
    textAlign: 'center',
  },
  subTitle: {
    fontWeight: 400,
    fontSize: '16px',
    textAlign: 'center',

  },
  closeIcon: {
    position: 'absolute',
    right: '15px',
    top: '15px',
    cursor: 'pointer',
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
  },
  comment: {
    padding: '10px',
  },
  buttons: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '10px',
  },
  button: {
    textTransform: 'uppercase',
  },
  uploadedFile: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderRadius: '8px',
    border: '1px solid rgba(0, 0, 0, 0.12)',
    padding: '16px',
    backgroundColor: 'rgba(241, 245, 249, 1)',
  },
  icon: {
    color: 'rgba(115, 115, 140, 1)',
    width: '20px',
  },
  fileName: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    fontWeight: 700,
    fontSize: '12px',
    color: 'rgba(0, 0, 0, 0.6)',
  },
  removeFile: {
    color: 'rgba(115, 115, 140, 1)',
    width: '16px',
    height: '16px',
    cursor: 'pointer',
  },
  loader: {
    color: '#fff',
  }
}))
